import { Box, Typography } from "@mui/material"

const Advertisement = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: 150, md: 500 },
        background: "papayawhip",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography align="center" fontWeight={700}>
        Advertisement
      </Typography>
    </Box>
  )
}
export default Advertisement
